module.exports = {
  adminApi: {
    url: 'https://nest-admin-api.staging.findify.io',
    version: 'v1',
    token: 'x-token',
    kcToken: 'kc',
  },
  adminApiLegacy: {
    url: 'https://admin.staging.findify.io',
    version: 'v1',
    onboarding: true,
    instagramOAuth: true,
  },
  searchApi: {
    url: 'https://api.staging.findify.io',
    version: 'v3',
  },
  analyticsApi: {
    url: 'https://analytics.staging.findify.io',
    version: 'v1',
  },
  tracking: {
    segmentAppId: 'VRAbP7G8y7jbc25qQynZhN6ZKUOcNcPj',
    gaAppId: 'UA-45221486-11',
  },
  gainSightTracking: {
    url: 'https://web-sdk.aptrinsic.com/api/aptrinsic.js',
    clientKey: 'AP-YEGV7FUNZB5J-2-2',
  },
  root: 'https://dashboard.staging.findify.io/',
  sentryDNS: 'https://c17223a5930f4d0eaed2a6891021cb4a@sentry.io/142954',
  onboardUrl: '//onboarding.staging.findify.io',
  inlineManual: {
    key: '9154eeda872bc978a5a1d35a21f824e7',
  },
  intercom: 'to8f49xr',
  unleash: {
    url: 'https://unleash.findify.io/api/frontend',
    clientKey:
      '*:development.99fc61c7ead0d4c57a07ecf3f6b1cb0ebcfa639ef7479fc9b0960434',
    appName: 'default',
    environment: 'development',
  },
  vueMerchantDashboardUrl: 'https://maropost-dashboard.staging.findify.io',
  maropost: {
    sign_in: 'https://id-staging.maropost.com',
  },
};
